module.exports = __webpack_public_path__ + "img/faq-logo.2848f571.png";